import './styles/CarrilesArco.css'
import React, { useEffect, useState } from 'react'
import Select from 'react-select'
import data_ubi from './ubicaciones'
import { useFetch } from '../hooks/useFetch'
import RowProblem from './RowProblem'
import LoadAlerts from './LoadAlerts'
const CarrilesArco = ({ hostId, server, languaje }) => {
  const carriles_list = useFetch('zabbix/hosts/detail/arcos', hostId, '', 'GET', server)

  return (
    <div className='ev-table-wrap' style={{ height: '300px' }}>
      <table className="ev-table">
        <thead className="ev-table-thead">
          <tr>
            <th style={{ width: '40px' }}>
              <input type="checkbox" disabled />
            </th>
            <th style={{ width: '25%' }}>Dirección</th>
            <th style={{ width: '25%' }}>Carril</th>
            <th style={{ width: '15%' }}>Lectura</th>
            <th style={{ width: '20%' }}>Última lectura</th>
            <th style={{ width: '15%' }}>IP</th>
          </tr>
        </thead>
        <tbody className="ev-table-tbody">
          {carriles_list.loading ? (
            <tr><td colSpan="6" style={{ textAlign: 'center', padding: '20px' }}><LoadAlerts languaje={languaje} /></td></tr>
          ) : (!carriles_list.data || !carriles_list.data.data || carriles_list.data.data.length === 0) ? (
            <tr><td colSpan="6" style={{ textAlign: 'center', padding: '20px', color: '#9ca3af' }}>Sin resultados</td></tr>
          ) : (
            carriles_list.data.data.map((elemento, indice) => (
              <tr key={indice} className="ev-table-row">
                <td>
                  <input type="checkbox" disabled />
                </td>
                <td>
                  <div className="ev-link">{elemento.Descripcion}</div>
                </td>
                <td className="txt-futuristic">{elemento.Carril}</td>
                <td className="txt-futuristic" style={{ fontWeight: '700', fontSize: '13px', color: elemento.Lecturas === 0 ? '#ef4444' : '#1e40af' }}>
                  {elemento.Lecturas}
                </td>
                <td className="txt-futuristic">{elemento.UltimaLectura}</td>
                <td className="txt-futuristic">{elemento.Ip}</td>
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  );
}

export default CarrilesArco